import React, { useState } from 'react'
import { Accordion } from 'react-bootstrap';
import { FaDownload, FaEdit } from 'react-icons/fa';
import { dateStringFormat } from 'utils/dateFormat';
import ChangeStatus from './ChangeStatus';
import { userPlaceholder } from 'assets/icons';

const RefillList = ({
    refill = [],
    refillList = () => { },
    userId,
    onEditOrder = () => { },
    onEditMedicine = () => { },
}) => {
    const [statusData, setStatusData] = useState({ modal: false })
    // console.log('refill', refill?.data)
    // ÷-----------------handle-change-status----------------
    const handleChangeStatus = (data) => {
        setStatusData({ ...data, modal: true })
    }
    // ÷-----------------handle-download-prescription----------------
    const handleDownload = async (url, fileName) => {
        try {
            const response = await fetch(url)
            const blob = await response.blob()
            const blobUrl = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = blobUrl
            link.download = fileName
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(blobUrl)
        } catch (error) {
            // fallback: open in a new tab if the file can not be fetched (CORS etc.)
            window.open(url, '_blank')
        }
    }
    return (
        <>
            {refill?.data?.length > 0 && refill?.data.map((data, ind) => (
                <Accordion key={ind} defaultActiveKey={ind} className='mb-2'>
                    <Accordion.Item eventKey={ind + 1}>
                        <Accordion.Header>
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <span>{data?.patientName}</span>
                                <span className="text-muted small">status: {data?.status || ''}</span>
                            </div>
                        </Accordion.Header>

                        <Accordion.Body>
                            <div className="container my-4">
                                {/* Title */}
                                <div className="button_wrap justify-content-end align-items-center">
                                    <button
                                        type="button"
                                        className="button light"
                                        onClick={() => onEditOrder(data)}
                                    >
                                        <FaEdit className="me-1" /> Edit Order
                                    </button>
                                    {/* {data?.status === 'PENDING' && (
                                        <button
                                            type="button"
                                            className="button light"
                                            onClick={() => onEditMedicine(data)}
                                        >
                                            <FaEdit className="me-1" /> Edit Medicine
                                        </button>
                                    )} */}
                                    {data?.status !== 'APPROVED' && (
                                        <button
                                            type="button"
                                            className="button"
                                            onClick={() => handleChangeStatus(data)}
                                            disabled={data?.status === 'REJECTED'}
                                        >
                                            {data?.status === 'REJECTED' ? 'REJECTED' : 'Change Status'}
                                        </button>
                                    )}
                                </div>
                                <h5 className="text-center text-primary fw-bold mb-4">Add Products/Medicine</h5>
                                <div className="d-flex gap-3 justify-content-center mb-4 flex-wrap">
                                    {data?.products.length > 0 ? data?.products.map((pItems, pInd) => (
                                        <div key={pInd} className="text-center border rounded p-2 shadow-sm">
                                            {pItems?.product?.image?.length > 0 && pItems?.product?.image.map((pImg, PImgId) => (
                                                <img
                                                    key={PImgId}
                                                    src={pImg ?? userPlaceholder}
                                                    alt={data?.productName}
                                                    className="img-fluid"
                                                    style={{ maxWidth: 100 }}
                                                />
                                            ))}
                                            <p className="mt-2 fw-medium small">{pItems?.product?.name}</p>
                                        </div>
                                        // </div>
                                    )) :
                                        <div className="text-center rounded p-2">
                                            No Products/Medicine
                                        </div>
                                    }
                                </div>
                                <h5 className="text-center text-primary fw-bold mb-4">Attach Medical Prescriptions </h5>
                                <div  className="d-flex gap-3 justify-content-center mb-4 flex-wrap">
                                    {data?.image.length > 0 ? data?.image.map((items, ind1) => (
                                        <div key={ind1} className="text-center border rounded p-2 shadow-sm position-relative">
                                            <button
                                                type="button"
                                                title="Download"
                                                className="btn btn-light border rounded-circle p-0 d-flex align-items-center justify-content-center position-absolute top-0 end-0 m-1 shadow-sm"
                                                style={{ width: 26, height: 26 }}
                                                onClick={() => handleDownload(items, `prescription-${data?._id || ind}-${ind1 + 1}.jpg`)}
                                            >
                                                <FaDownload size={12} className="text-primary" />
                                            </button>
                                            <img
                                                src={items}
                                                alt={data?.productName}
                                                className="img-fluid"
                                                style={{ width: 100, height: 100, objectFit: 'contain' }}
                                            />
                                        </div>
                                    )) :
                                        <div className="text-center rounded p-2">
                                            No Medical Prescriptions
                                        </div>
                                    }
                                </div>

                                {/* Patient Info */}
                                < div className="mb-3" >
                                    <p className="fw-semibold mb-1">Patient Name</p>
                                    <p className="text-primary fw-bold">{data?.patientName || "N/A"}</p>
                                </div>

                                {/* Date */}
                                <div className="mb-3">
                                    <p className="fw-semibold mb-1">Date</p>
                                    <p className="text-dark">{dateStringFormat(data?.startDate)}</p>
                                </div>

                                {/* Refill Cycle */}
                                <div className="mb-3">
                                    <p className="fw-semibold mb-1">Medicine Refill Cycle (in Days)</p>
                                    <p className="text-dark">{data?.refillCycle ? `${data?.refillCycle} Days` : 'N/A'} </p>
                                </div>

                                {/* Address */}
                                <div className="mb-2">
                                    <p className="fw-semibold mb-1">Selected Address</p>
                                    <div className="border rounded p-3 bg-light shadow-sm w-25">
                                        <span className="badge bg-light text-primary border px-3 py-2 mb-2">{data?.addressDetails?.type || "N/A"}</span>
                                        <p className="mb-0 text-dark small">{data?.addressDetails?.address || "N/A"} </p>
                                    </div>
                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion >
            ))}
            <ChangeStatus
                show={statusData?.modal}
                close={() => setStatusData({ ...statusData, modal: false })}
                statusData={statusData}
                refillList={refillList}
                userId={userId}
            />
        </>
    )
}

export default RefillList
